import { BaseApiRouteService } from "mrb/core";

class LoadioGenreApiRouteService extends BaseApiRouteService {
    constructor() {
        super("loadio/genres");
    }

    find(filter) {
        return super.find(`${this.base}{?searchQuery,page,rpp,sort,embed,fields}`, filter);
    }
}

export default LoadioGenreApiRouteService;
